import {useState} from 'react'

import 'flatpickr/dist/themes/airbnb.css'
import Flatpickr from 'react-flatpickr'
import {useIntl} from 'react-intl'
import {useRenewMemberTransactions} from '../../context/useQuery'
import {useMember} from '../../hook'

interface FilterDrawerProps {
  open: boolean
  setOpen: (open: boolean) => void
  memberId: string
}

export default function FilterDrawerTrx({open, setOpen, memberId}: FilterDrawerProps) {
  const intl = useIntl()
  const [value, setValue] = useState('')
  const [tpnId, setTpnId] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const {listFilterTrx, listFilterSetTrx} = useMember()
  const {handleRefresh} = useRenewMemberTransactions(memberId)

  const handleRenewTrx = () => {
    handleRefresh()
  }

  const submitFilter = () => {
    let date: any = []

    // if (moment(startDate).isAfter(endDate)) {
    //   toast.error("Start date can't be after end date")
    //   return
    // }

    if (startDate) {
      const year = new Date(startDate).getFullYear()
      const month =
        new Date(startDate).getMonth() < 9
          ? `0${new Date(startDate).getMonth() + 1}`
          : new Date(startDate).getMonth() + 1
      const day = new Date(startDate).getDate()

      const dateM = `${year}-${month}-${day}T00:00:00.000Z`

      date = [
        {
          key: 'crtdDt', //Enrollment Date
          operator: 9, //GreaterThan
          logicalOp: 2,
          value: [dateM],
          childFilters: [],
        },
      ]
    }

    if (endDate) {
      const year = new Date(endDate).getFullYear()
      const month =
        new Date(endDate).getMonth() < 9
          ? `0${new Date(endDate).getMonth() + 1}`
          : new Date(endDate).getMonth() + 1
      const day = new Date(endDate).getDate()

      const dateM = `${year}-${month}-${day}T23:59:59.000Z`

      date = [
        ...date,
        {
          key: 'crtdDt', //Enrollment Date
          operator: 10, //LessThan
          logicalOp: 2,
          value: [dateM],
          childFilters: [],
        },
      ]
    }

    listFilterSetTrx({
      ...listFilterTrx,
      paging: {
        ...listFilterTrx.paging,
        currentPageNumber: 1,
      },
      filterList: [
        {
          /* key: '_id', */
          key: 'refID',
          operator: 14,
          logicalOp: 2,
          value: [value || ''],
          childFilters: [
            {
              key: 'psNo',
              operator: 14,
              logicalOp: 2,
              value: [value || ''],
              childFilters: [],
            },
          ],
        },

        // {
        //   key: 'date',
        //   operator: 7,
        //   logicalOp: 2,
        //   value: [startDate || ''],
        //   childFilters: [],
        // },
        // {
        //   key: 'date',
        //   operator: 8,
        //   logicalOp: 2,
        //   value: [endDate || ''],
        //   childFilters: [],
        // },

        ...date,
      ],
    })

    setOpen(false)
  }

  function toTimestamp(strDate) {
    var datum = Date.parse(strDate)
    return datum / 1000
  }

  const startDateTime = startDate ? toTimestamp(startDate) : 0
  const endDateTime = endDate ? toTimestamp(endDate) : 0

  const dateValidate: boolean = startDate && endDate && startDateTime > endDateTime ? true : false

  const handleReset = () => {
    setOpen(false)
    setValue('')
    setStartDate(null)
    setEndDate(null)
    setTpnId('')
    listFilterSetTrx({
      ...listFilterTrx,
      filterList: [],
    })
    handleRenewTrx()
  }

  return (
    <>
      {open && <div className='drawer-overlay' onClick={() => setOpen(false)}></div>}
      <div
        className={`bg-body custom-drawer drawer drawer-end ${open ? 'drawer-on' : ''}`}
        // id='kt_filter_membertrx'
        // className='bg-body'
        // data-kt-drawer='true'
        // data-kt-drawer-width='{default: "300px", "lg": "375px"}'
        // data-kt-drawer-activate='true'
        // data-kt-drawer-toggle='#kt_filter_membertrx_button'
        // data-kt-drawer-close='#kt_filter_membertrx_close'
      >
        <div className='card rounded-0 w-100'>
          <div className='card-header pe-5'>
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 lh-1'>
                  {intl.formatMessage({id: 'GLOBAL.FILTER.SELECTED'})}
                </span>
              </div>
            </div>

            <div className='card-toolbar'>
              <div
                className='btn btn-sm btn-icon btn-active-light-primary'
                id='kt_drawer_example_basic_close'
              >
                <span className='svg-icon svg-icon-2'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <rect
                      opacity='0.5'
                      x='6'
                      y='17.3137'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(-45 6 17.3137)'
                      fill='black'
                    ></rect>
                    <rect
                      x='7.41422'
                      y='6'
                      width='16'
                      height='2'
                      rx='1'
                      transform='rotate(45 7.41422 6)'
                      fill='black'
                    ></rect>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div className='card-body hover-scroll-overlay-y'>
            <form id='filterForm'>
              <div className='px-7 py-5'>
                <div className='mb-5'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.REF_ID_SEARCH'})}:
                  </label>

                  <div className='row'>
                    <div className='col-md-12 mb-4'>
                      <input
                        className='form-control mr-sm-2'
                        type='search'
                        name='productSelectedSearch'
                        placeholder={intl.formatMessage({
                          id: 'MEMBER.DETAIL.TRANSACTIONS.REF_ID',
                        })}
                        aria-label='Search'
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className='mb-5'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS.DATE_TIME_SEARCH'})}:
                  </label>

                  <div className='row'>
                    <div className='col-md-6 mb-4'>
                      <Flatpickr
                        placeholder={intl.formatMessage({
                          id: 'MEMBER.DETAIL.TRANSACTIONS.DATE_TIME_START_DATE',
                        })}
                        value={startDate}
                        onChange={(date) => {
                          setStartDate(date[0])
                        }}
                        name='startDate'
                        className='form-control mb-2'
                        options={{dateFormat: 'm/d/Y'}}
                      />
                    </div>
                    <div className='col-md-6 mb-4'>
                      <Flatpickr
                        placeholder={intl.formatMessage({
                          id: 'MEMBER.DETAIL.TRANSACTIONS.DATE_TIME_END_DATE',
                        })}
                        value={endDate}
                        onChange={(date) => {
                          setEndDate(date[0])
                        }}
                        name='endDate'
                        className='form-control mb-2'
                        options={{dateFormat: 'm/d/Y'}}
                      />

                      {dateValidate && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            {intl.formatMessage({
                              id: 'GLOBAL.VALIDATION.END_DATE_MUST_BE_GREATER_THAN_START_DATE',
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* 
                <div className='mb-5'>
                  <label className='form-label fw-bold'>
                    {intl.formatMessage({ id: 'TRANSACTION.TERMINAL_ID' })}:
                  </label>

                  <div className='row'>
                    <div className='col-md-12 mb-4'>
                      <input
                        className='form-control mr-sm-2'
                        type='search'
                        name='productSelectedSearch'
                        placeholder={intl.formatMessage({
                          id: 'TRANSACTION.TERMINAL_ID',
                        })}
                        aria-label='Search'
                        value={tpnId}
                        onChange={(e) => setTpnId(e.target.value)}
                      />
                    </div>
                  </div>
                </div> */}
              </div>
            </form>
          </div>

          <div className='card-footer'>
            <div className='row'>
              <div className='col-md-6'>
                <button
                  type='reset'
                  className='btn w-100 btn-sm btn-light-danger'
                  onClick={handleReset}
                >
                  {intl.formatMessage({id: 'GLOBAL.FILTER.CLEAR'})}
                </button>
              </div>
              <div className='col-md-6'>
                <button
                  className='btn w-100 btn-sm btn-primary'
                  disabled={dateValidate}
                  onClick={() => {
                    submitFilter()
                  }}
                >
                  {intl.formatMessage({id: 'GLOBAL.FILTER.SEARCH'})}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
